<mat-card class="portal-public-list">
  <mat-card-title>
    <div class="flex flex-col md:flex-row md:gap-4">
      <h1 class="portal-page-title">Licensed In Home Care Agencies</h1>
      <button class="ml-auto" mat-button color="primary" (click)="downloadDocument()">Export List as CSV</button>
    </div>
  </mat-card-title>
  <mat-card-content>
    <mat-table [dataSource]="agencySource" matSort #agencySort="matSort" aria-label="licensed agencies" class="portal-table">
      <ng-container matColumnDef="licenseNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header>License</mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label">License</span>
          {{ agency.licenseNumber }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="expirationDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Expiration Date</mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label">Expires</span>
          {{ agency.expirationDate | date: 'MM/dd/yyyy' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="legalName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Legal Name</mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label">Legal Name</span>
          {{ agency.legalName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="dba">
        <mat-header-cell *matHeaderCellDef mat-sort-header><abbr title="Doing Business As">DBA</abbr></mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label"><abbr title="Doing Business As">DBA</abbr></span>
          {{ agency.dba }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="classification">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Classification</mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label">Classification</span>
          {{ agency.classification }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="street">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Street</mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label">Street</span>
          {{ agency.street }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">City</mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label">City</span>
          {{ agency.city }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="state">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">State</mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label">State</span>
          {{ agency.state }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="zip">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Zip</mat-header-cell>
        <mat-cell *matCellDef="let agency">
          <span class="mobile-label">Zip</span>
          {{ agency.zip }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="agencyColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: agencyColumns" class="portal-interactive-row"
               [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" #agencyPaginator="matPaginator">
    </mat-paginator>
  </mat-card-content>
</mat-card>
